











































































import { Vue, Component } from 'vue-property-decorator';
import { Action, State, Getter } from 'vuex-class';
import timeFormat from '@/utils/timeFormat';

@Component
export default class Header extends Vue {
  @Getter('duration') private duration: any;
  @Action('SET_DURATION') private SET_DURATION: any;
  private show: boolean = false;
  private auto: boolean = false;
  private autoTime: number = 6;
  private timer: any = null;
  private handleReload() {
    const gap = this.duration.end.getTime() - this.duration.start.getTime();
    const utcCopy: any = -(new Date().getTimezoneOffset() / 60);
    const time: Date[] = [new Date(new Date().getTime() - gap), new Date()];
    this.SET_DURATION(timeFormat(time));
  }
  private handleAuto() {
    this.auto = !this.auto;
    if (this.auto) {
      this.handleReload();
      this.timer = setInterval(this.handleReload, this.autoTime * 1000);
    } else {
      clearInterval(this.timer);
    }
  }
  private handleHide() {
    this.show = false;
  }
  private handleShow() {
    this.show = !this.show;
  }
  private handleSignout() {
    localStorage.removeItem('skywalking-authority');
    this.$router.push('/login');
  }
  private changeAutoTime() {
    clearInterval(this.timer);
    if (this.auto) {
      this.handleReload();
      this.timer = setInterval(this.handleReload, this.autoTime * 1000);
    }
  }
}
